import { render } from "./FAQQuestionDetailTasks.vue?vue&type=template&id=6c5d916a&scoped=true"
import script from "./FAQQuestionDetailTasks.vue?vue&type=script&lang=js"
export * from "./FAQQuestionDetailTasks.vue?vue&type=script&lang=js"

import "./FAQQuestionDetailTasks.vue?vue&type=style&index=0&id=6c5d916a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5d916a"]])

export default __exports__